import {Component, ContentChildren, EventEmitter, HostBinding, Input, Output, QueryList, TemplateRef} from '@angular/core';
import {ExplorerItem, TreeNodeInfo} from '@catmodules/ui-base/types';
import {NodePathRef} from '@catmodules/widgets/explorer/types';
import {isNullOrUndefined} from 'util';

const componentBaseName = 'tree-node';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');
const unsetItem = {value: null, label: null};
const defaultMsgNoItemsFound = 'No items yet.';

@Component({
  selector: 'cat-tree-node',
  templateUrl: './tree-node.component.html',
  styleUrls: ['./tree-node.component.scss'],
})
export class TreeNodeComponent {
  @HostBinding('class') classNames = defaultClassNames;

  @ContentChildren(TemplateRef) innerTemplates: QueryList<any>;

  @Input() pathToRef: NodePathRef[] = [];
  @Input() item: ExplorerItem;
  @Input() activeItem: ExplorerItem;
  @Input() hoverDivGenerator: (nodeInfo: TreeNodeInfo) => HTMLDivElement | null = null;

  @Input()
  set treeDepth(value: number) {
    this._treeDepth = value;
    this.templateKeyRef = `nodeLevel${this.treeDepth}`;

  }

  get treeDepth(): number {
    return this._treeDepth;
  }

  @Input() index: number;
  @Input() templates: Map<string, any> = new Map();
  @Input() customBehaviour = false;
  @Output() onActivate = new EventEmitter<TreeNodeInfo>();

  private _treeDepth: number;
  private templateKeyRef: string;

  protected hoverDiv: HTMLDivElement = null;

  get hasCustomTemplateForNode() {
    const currentKey = this.templateKeyRef;
    const template = this.templates.get(this.templateKeyRef);
    return !isNullOrUndefined(template);
  }

  /**
   * Returns true if the current activeItem matches with the provided one
   * @param {ExplorerItem} item
   * @returns {boolean}
   */
  get isCurrentActive() {
    return this.item === this.activeItem;
  }

  get isFullCustomizable() {
    return this.customBehaviour && this.hasCustomTemplateForNode;
  }

  constructor() {
  }

  /**
   * Wraps a ExplorerItem into a TreeNodeInfo
   *
   * @param {ExplorerItem} item
   * @returns {TreeNodeInfo}
   */
  asTreeNode(item: ExplorerItem): TreeNodeInfo {
    const params = {index: this.index, nodeLevel: this.treeDepth, pathToRef: this.pathToRef};

    return {
      item,
      nodeLevel: this.treeDepth,
      isCustom: this.hasCustomTemplateForNode,
      processed: false,
      params,
    };
  }

  /**
   * Propagate current active item to the next parent level
   * If the origin of the current active item is not on the current level, the original nodeLevel is determined and propagated
   * Also initiate propagting the current node level to the current route as a parameter, if required.
   *
   * @param value
   */
  onClickItem(value: ExplorerItem) {
    const treeNodeInfo = this.asTreeNode(value);
    this.onActivate.emit(treeNodeInfo);
  }

  onMouseEntersItem(value: ExplorerItem, event : Event) {
    if (!this.hoverDivGenerator) return;
    const treeNodeInfo = this.asTreeNode(value);
    this.hoverDiv = this.hoverDivGenerator(treeNodeInfo);;
    setTimeout(() => {
        const hoverDiv = $("#hoverDiv").get(0) as HTMLDivElement;
        if (!hoverDiv) return;
        hoverDiv.style.top = ((window.innerHeight - hoverDiv.clientHeight) / 2) + "px";
        hoverDiv.style.visibility = "visible";
    }, 650);
  }

  onMouseLeavesItem(value: ExplorerItem) {
    if (!this.hoverDivGenerator) return;
    this.hoverDiv = null;
  }

  /**
   * Determines if a custom template was provided to this components node depth level und if so, returns it
   *
   * @returns {any}
   */
  getCustomTemplateForNode() {
    const currentKey = this.templateKeyRef;
    let template = null;

    if (this.hasCustomTemplateForNode) {
      template = this.templates.get(currentKey);
    }

    return template;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/widgets/explorer/components/tree-node/tree-node.component.ts